import { render, staticRenderFns } from "./ElementLoading.vue?vue&type=template&id=ddaa728e&scoped=true"
import script from "./ElementLoading.vue?vue&type=script&lang=js"
export * from "./ElementLoading.vue?vue&type=script&lang=js"
import style0 from "./ElementLoading.vue?vue&type=style&index=0&id=ddaa728e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddaa728e",
  null
  
)

export default component.exports